module.exports = __webpack_public_path__ + "images/referenzen/animationsfilm/saxovent_animationsfilm_small.jpg";